import { useEffect, useRef, useState } from "react";
import { pincodeService } from "../services/pincode.service";

const NOT_FOUND =
  "Invalid or unavailable pincode. Please check the 6-digit pincode.";

export default function usePincodeLookup(pincode, onResolved) {
  const [status, setStatus] = useState({ type: "idle", message: "" });
  const onResolvedRef = useRef(onResolved);
  const lastSuccessPinRef = useRef("");
  const hadSixRef = useRef(false);
  onResolvedRef.current = onResolved;

  useEffect(() => {
    const pin = String(pincode || "").replace(/\D/g, "");

    if (pin.length !== 6) {
      if (hadSixRef.current) {
        hadSixRef.current = false;
        lastSuccessPinRef.current = "";
        onResolvedRef.current?.({ clear: true });
      }
      setStatus({ type: "idle", message: "" });
      return undefined;
    }

    hadSixRef.current = true;
    if (lastSuccessPinRef.current === pin) return undefined;

    let cancelled = false;
    setStatus({ type: "loading", message: "Checking…" });

    pincodeService
      .lookup(pin)
      .then((res) => {
        if (cancelled) return;
        const data = res?.data?.data || res?.data || {};
        if (!data.city && !data.district && !data.state) {
          setStatus({ type: "error", message: NOT_FOUND });
          onResolvedRef.current?.({ error: true });
          return;
        }
        lastSuccessPinRef.current = pin;
        setStatus({
          type: "success",
          message: data.area
            ? `Auto-filled from ${data.area}, ${data.state}`
            : `Auto-filled: ${data.city || data.district}, ${data.state}`,
        });
        onResolvedRef.current?.({
          city: data.city || data.district || "",
          district: data.district || data.city || "",
          state: data.state || "",
          area: data.area || "",
        });
      })
      .catch((err) => {
        if (cancelled) return;
        setStatus({
          type: "error",
          message: err?.response?.data?.message || NOT_FOUND,
        });
        onResolvedRef.current?.({ error: true });
      });

    return () => {
      cancelled = true;
    };
  }, [pincode]);

  return status;
}
